import React from "react";
import LeftMenu from "./LeftMenu";
import TopNavbar from "./TopNavbar";
import {
  Col,
  Row,
  Container,
} from "reactstrap";


const Layout = ({ Component, route, props }) => {

    return (
        <>
            <div className="">
                <section>
                    <Container fluid>
                        <Row>
                            <Col xl="2" lg="3">
                                <LeftMenu />
                            </Col>
                            <Col xl="10" lg="9">
                                <TopNavbar />
                                <Component route={route} />
                            </Col>
                        </Row>
                        
                    </Container>
                </section>
            </div>
        </>
    );

};

export default Layout;